import { AxiosInstance, AxiosRequestConfig } from 'axios';
const ENDPOINT = 'file/';

export type SharedPhoto = {
  content: string;
  filename: string;
  last_update: string;
};

export type SharedPhotoDescriptor = {
  photo: SharedPhoto;
  full_address: string;
  outlet: EntityBase;
  user: string;
  visit_dt: string;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (instance: AxiosInstance, config: AxiosRequestConfig) => ({
  getPhotoShare: (hash: string) =>
    instance.get<ApiResponse<SharedPhotoDescriptor>>(ENDPOINT + `image/share/${hash}/`, {...config}),
});
